export default function Login() {
    return (
      <section className="page">
        <h2>Login</h2>
        <p>Login form placeholder.</p>
      </section>
    );
  }